module.exports = __webpack_public_path__ + "static/media/striped_bar_AERO_hand.2846f012.svg";